import { useEffect } from "react";

type Schema = Record<string, unknown>;

export function useStructuredData(id: string, schema: Schema | null) {
  const serialized = schema ? JSON.stringify(schema) : null;

  useEffect(() => {
    if (!serialized) return;

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.text = serialized;
    document.head.appendChild(script);

    return () => {
      document.getElementById(id)?.remove();
    };
  }, [id, serialized]);
}
